var path = 'app/sections/campaigns/campaignPrognosisTooltipPopup.html';
var html = "<div class=\"prognosis-tooltip\">\n  <div>{{\"campaigns.labels.livePrognosis.hints.\" + content.type | i18n}}</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;